import xw from 'xwind';
import styled from '@emotion/styled';

export const Title = styled.h1(
  xw`
    text-4xl text-center 
    text-active mb-5
  `,
);

export const Line = styled.hr(
  xw`
    mx-auto h-0.5 rounded-sm 
    border-0 bg-secondary w-36 mb-7
  `,
);

export const Contant = styled.div(
  `
  margin: 50px 0;
  h1 {
    margin-bottom: 15px;
    font-weight: 900;
    font-size: 28px;     
  }
  h2 {
    margin: 65px 0 15px;
    font-weight: 900;
    font-size: 32px;     
  }
  h3 {
    margin-bottom: 15px;
    font-weight: 900;
    font-size: 25px;     
  }
  h4 {
    margin-bottom: 15px;
    font-weight: 900;
    font-size: 22px;     
  }
  h5 {
    margin-bottom: 15px;
    font-weight: 900;
    font-size: 20px;     
  }
  h6 {
    margin-bottom: 15px;
    font-weight: 900;
    font-size: 18px;     
  }
  p {
    font-size: 20px; 
    margin: 0 0 15px 0;
  }
  ul {
    display: block;
    margin: 0 0 15px 37px;
    padding: 0;
  }
  ul ul {
    margin-top: 15px;
  }
  ul li {
    list-style: none;
    background: url(icons/ellipse.svg) no-repeat 0 10px;
    padding-left: 24px;
  }
  ul ul li {
    background: url(icons/empty_ellipse.svg) no-repeat 0 10px;
  }
  a {
    text-decoration-line: underline;
  }
  @media screen and (max-width: 640px) {
    h2 {
      margin: 35px 0 15px;
      font-weight: 900;
      font-size: 28px;     
    }
    h3 {
      margin-bottom: 15px;
      font-weight: 900;
      font-size: 23px;     
    }
    ul {
      margin: 0 0 0 15px;
    }
    p {
      font-size: 16px; 
    }
  }
  `,
);
